export default function Join() {
  return (
    <section id="join" className="relative overflow-hidden bg-primary-600">
      <div className="pointer-events-none absolute -left-20 -top-16 h-56 w-56 rounded-full bg-primary-400/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-16 right-0 h-56 w-56 rounded-full bg-secondary-400/30 blur-3xl"></div>
      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center gap-5 px-4 py-12 text-center md:px-6 md:py-16">
        <h2 className="max-w-2xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
          准备好看料、聊料、涨见识了吗？
        </h2>
        <p className="max-w-xl text-base leading-relaxed text-primary-100">
          加入看料社，找到同好，把每一次看料都聊出价值。现在就来，从第一条真实分享开始。
        </p>
        <div className="mt-2 flex flex-col gap-3 sm:flex-row">
          <a
            href="#join"
            onClick={(e) => e.preventDefault()}
            className="whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 hover:bg-secondary-100 transition-colors cursor-pointer"
          >
            <i className="ri-user-add-line mr-2"></i>免费加入
          </a>
          <a
            href="#highlights"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#highlights')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap rounded-md border border-background-50/60 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-500 transition-colors cursor-pointer"
          >
            先看看心得
          </a>
        </div>
      </div>
    </section>
  );
}